import { inject } from '@angular/core'
import { Router } from '@angular/router'

import { OperatorDataState } from '@states/operator-data'

export const requireGuestGuard = () => {
	const router = inject(Router)
	const operatorDataState = inject(OperatorDataState)

	return !operatorDataState.isAuthed() || router.createUrlTree(['/'])
}
